import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'primereact/toast';
import './drop-file-input.css';

import { ImageConfig } from '../../config/ImageConfig';
import uploadImg from '../../assets/cloud-upload-regular-240.png';
import { Col, Row } from 'react-bootstrap';

const DropFileInput = props => {

    const wrapperRef = useRef(null);
    const toast = useRef(null);

    const [fileList, setFileList] = useState([]);

    const onDragEnter = () => wrapperRef.current.classList.add('dragover');

    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');

    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {


        const newFile = e.target.files[0];
        
        const maxSizeInBytes = 5 * 1024 * 1024;
        const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']; 
        if (!allowedTypes.includes(newFile?.type)) {
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'Invalid file type',
              description:"Please upload an image (JPEG/PNG) or a PDF"
              ,
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                    <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                    <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                </div>
              ),
            });
        
        }else     
        if (newFile.size > maxSizeInBytes) {
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'File size exceeds the limit',
              description:"Please upload a file less than 5 MB"
              ,
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                    <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                    <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                </div>
              ),
            });                  
        }else
        if (newFile) {
            const currentfile = props.values[props.formik_location]
             const updatedList = [...fileList, newFile];
             setFileList(updatedList);

             const updatedData = [...currentfile,newFile]               
            


             props.setFieldValue(props.formik_location, updatedData);
        }
        

    }

    const fileRemove = (file) => {
        const updatedList = [...fileList];
        updatedList.splice(fileList.indexOf(file), 1);
        setFileList(updatedList);
       


        const currentfile = props.values[props.formik_location]
    
      
        const updatedProofDoc = currentfile.filter(item => item !== file);
    
      
      
    
        
        props.setFieldValue(props.formik_location, updatedProofDoc);
  
        
    };

    return (
        <div className='d-flex justify-content-center flex-column' style={{ width: "100%" }}>
            <Toast ref={toast}  position="top-center"  />
            <label className='pt-3 ps-3' style={{ height: "100%" }}>Proof Documents</label>
            {props.error && <small style={{ color: "red" }} className=' ps-3'>{props.error}</small>}

            <table style={{ fontSize: '13px' , marginLeft:'15px'}}>
                <tbody>
                    <tr>
                        <td>NIC Proof</td>
                        <td>: Valid government-issued photo identification required, such as a passport, driver's license, or national ID card.</td>
                    </tr>
                    <tr>
                        <td>Address Proof</td>
                        <td>: Recent utility bill, bank statement, or lease agreement showing current address, issued within the last three months.</td>
                    </tr>
                    <tr>
                        <td>Name Proof</td>
                        <td>: Legal document indicating name change, such as a marriage certificate, divorce decree, or court order.</td>
                    </tr>
                </tbody>
            </table>



            <Row className='my-4'>
                <Col xs={12}>
                    <div
                        ref={wrapperRef}
                        className={`drop-file-input`}
                        onDragEnter={onDragEnter}
                        onDragLeave={onDragLeave}
                        onDrop={onDrop}
                        style={{ borderColor: `${props.error ? 'red' : '#11B1F0'}` }}
                    >
                        <div className="drop-file-input__label d-flex justify-content-center flex-column">
                            <div className='d-flex justify-content-center'>
                                <img src={uploadImg} alt="" />
                            </div>
                            <p>Drag & Drop your files here</p>
                        </div>
                        <input type="file" name='nominee_proof_doc' onChange={onFileDrop} required />
                    </div>
                </Col>

            </Row>
            <Row>
                <Col xs={12}>
                    {
                        fileList.length > 0 ? (
                            <div className="drop-file-preview">
                                <p className="drop-file-preview__title">
                                    Ready to upload
                                </p>
                                {
                                    fileList.map((item, index) => (
                                        <div key={index} className="drop-file-preview__item">
                                            <img src={ImageConfig[item.type.split('/')[1]] || ImageConfig['default']} alt="" />
                                            <div className="drop-file-preview__item__info">
                                                <p>{item.name}</p>
                                                <p>{item.size}B</p>
                                            </div>
                                            <span className="drop-file-preview__item__del" onClick={() => fileRemove(item)}>x</span>
                                        </div>
                                    ))
                                }
                            </div>
                        ) : null
                    }
                </Col>
            </Row>
        </div>
    );
}

DropFileInput.propTypes = {
    onFileChange: PropTypes.func
}

export default DropFileInput;
